import React, { useState, useEffect, useRef } from 'react';
//Banner
import banner1landing from '../assets/sliders/fondoRojo.jpg';
import banner2landing from '../assets/sliders/fondoBlanco.jpg';
import banner3landing from '../assets/sliders/fondoNegro.jpg';

import vasobanner04 from '../assets/sliders/VasoBanner04.png';

import vasoRBD from '../assets/sliders/VasoBanner01.png';

//Sticker Vaso Slider
import vasoRBDHuge from '../assets/sliders/VasoRBD.jpg';
import vasoMoanaHuge from '../assets/sliders/VasoMoana.webp';
import vasoBaseballHuge from '../assets/sliders/VasoBeisbol.webp';


//Logos Slider 2
import logoDisney from '../assets/sliders/Disney_Color.png';
import logoNBCU from '../assets/sliders/NBCUniversal_Color.png';

//Slider 4
import vasoFlowerHuge from '../assets/sliders/VasoBanner04.png';
//Vaso Cervecero
import vasoCervecero from '../assets/vasocervecero/VasoCervecero.png';
import backgroundVasoCervecero from '../assets/vasocervecero/ElipseVasoCervecero.png';

//Vaso Cafetero
import vasoCafetero from '../assets/vasocafetero/VasoCafetero.png';
import backgroundVasoCafetero from '../assets/vasocafetero/ElipseVasoCafetero.png';

//Vasos IML
import AnimacionVasos from '../functions/AnimacionVasos';
import vasoIML1 from '../assets/vasosIML/VasoCafetero01.png';
import vasoIML2 from '../assets/vasosIML/VasoCafetero02.png';
import vasoIML3 from '../assets/vasosIML/vasoCerveceroTapa02.webp';
import backgroundVasosIML from '../assets/vasosIML/ElipseEstrategias.png';

//Immpresión Híbrida
import impresionDigitalHibrida from '../assets/ElipseImpresion.png';
//Check
import imgCheck from '../assets/Check.png';

import vasoColoreable from '../assets/vasos/vaso-coloreable.webp';
import vasoHighGloss from '../assets/vasos/vaso-High-Gloss.webp';
import vasoLisoBrillante from '../assets/vasos/vaso-liso-brillante.webp';
import vasoMetalizado from '../assets/vasos/vaso-metalizado.webp';
import vasoOrangePeel from '../assets/vasos/vaso-orange-peel.webp';
import vasoTransparente from '../assets/vasos/vaso-transparente.webp';
import vasoTermocromatico from '../assets/vasos/vaso-termocromatico.webp';

const vasos = [
  { src: vasoColoreable, nombre: "Coloreable" },
  { src: vasoHighGloss, nombre: "High Gloss" },
  { src: vasoLisoBrillante, nombre: "Liso Brillante" },
  { src: vasoMetalizado, nombre: "Metalizado" },
  { src: vasoOrangePeel, nombre: "Orange Peel" },
  { src: vasoTransparente, nombre: "Transparente" },
  { src: vasoTermocromatico, nombre: "Termocromatico" },
];

function Landing() {
  const vasosLanding = [
      {
        id: 1,
        nombre: 'Vaso para bebidas frías.',
        sub: 'Más grande. Más ligero. Más competitivo.',
        subdescrip:'32 oz',
        descripcion:'El vaso que redefine lo que significa impacto masivo.',
        descripcion2:['En Mega Label hacemos que tu marca siempre destaque del resto y con nuestros vasos promocionales para bebidas frías con capacidad de 32 oz otorgamos algo más que un solo vaso, brindamos innovación, calidad y personalización.',
      ],
        caracteristicas: [
          ['Mayor capacidad, ideal para grandes volúmenes.'], 
          ['Capa delgada: más ligero y económico.'], 
          ['Certificación grado alimenticio.'],
          ['Personalización total con acabados únicos.'],
        ],
        imgvaso: vasoCervecero,
        imgbackgroundvaso: backgroundVasoCervecero,
        frase:['Vuélvete el vaso favorito de tus clientes. ',<strong>Nunca lo querrán soltar.</strong>,
        ],
        buttonfrase: 'Cotiza tu proyecto ',
      },
      {
        id: 2,
        nombre: 'Vaso para bebidas calientes.',
        subdescrip:'24 oz',
        sub: 'Mantén tu marca presente.',
        descripcion:'Un regalo que no parece regalo.',
        descripcion2:[
          'Con una capa que resiste el calor sin deformarse, este vaso no solo protege las manos, también protege la imagen de tu marca.',
          'Nuestras etiquetas In-Mold (IML) mantienen tu marca intacta por más tiempo, multiplicando los impactos de visibilidad: un solo vaso puede llegar a manos y lugares que ni imaginabas.',
        ],
        caracteristicas: [
          ['Acabados únicos como piel de naranja, metálico, coloreable, etc.'], 
          ['Su diseño y calidad hacen que nadie lo perciba como un simple promocional, sino un regalo premium.'], 
          ['Certificación grado alimenticio.'],
          ['Disponible en 24oz.'],
        ],
        imgvaso: vasoCafetero ,
        imgbackgroundvaso: backgroundVasoCafetero,
        frase:['Si lo piensas bien, ',<strong>impactas más y de cerca</strong>,'que con un espectacular.',
        ],
        buttonfrase: 'Cotiza con nosotros',
      },
    ];

    

  //Movimiento de Vaso Cervecero
  const vasoCerveceroRef = useRef(null);
  const destinoVasoCerveceroRef = useRef(null);

  const vasoCafeteroRef = useRef(null);
  const destinoVasoCafeteroRef = useRef(null);

  const vasoIMLRef = useRef(null);
  const destinoVasoIMLRef = useRef(null);

  //Vaso Cervecero
  // Efecto Scroll
  useEffect(() => {
    const handleScroll = () => {  
      if (!vasoCerveceroRef.current || !destinoVasoCerveceroRef.current) return;
      //const startOffset = 120;
      // Altura de la pantalla (centro)
      const halfScreen = window.innerHeight / 2;
      const startOffset = halfScreen;
      const vaso = vasoCerveceroRef.current;

      const contenedor = vasoCerveceroRef.current; // contenedor del vaso y background
      const vasoCervecero = contenedor.querySelector(".vaso-scroll"); // solo el vaso
      const background = contenedor.querySelector(".background-vasoscroll"); // solo el background

      const startY = vaso.offsetTop; // posición inicial del vaso
      const startPoint = startY + startOffset;
      const endY = destinoVasoCerveceroRef.current.offsetTop; // posición destino
      const scrollY = window.scrollY + window.innerHeight / 2; // referencia de scroll

      // Normalizamos progreso entre 0 y 1
      let progress = (scrollY - startY) / (endY - startY);
      progress = Math.min(Math.max(progress, 0), 1);
      //console.log(progress);

       

      // Rotación progresiva hasta -5°
      const rotation = progress * -5;

      if (scrollY < startPoint) {
        // Antes de llegar al inicio → vuelve a su lugar
        vaso.style.transition = `transform 1.5s`;
        vasoCervecero.style.transform = `rotate(${rotation}deg)`;
        vaso.style.transform = `translateY(${progress * (endY - startY)}px)`;
      } else if (scrollY >= startPoint && scrollY < endY) {
        // En movimiento
        vasoCervecero.style.transform = `rotate(${rotation}deg)`;
        //console.log(endY);
        //vaso.style.transform = `translateY(${progress * (endY - startY)}px)`;
        vaso.style.transition = `transform 0.7s`;
        vaso.style.transform = `translateY(${progress * halfScreen}px)`;
        //vaso.style.transform = `translateY(${progress * 600}px)`;
      } else {
        // Cuando ya pasó el destino → fijo en el destino
        //vaso.style.transform = `translateY(${endY - startY}px)`;
        //console.log(endY);
        vaso.style.transition = `transform 0.9s`;
        vaso.style.transform = `translateY(${endY - startY}px)`;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

//Vaso Cafetero
    // Efecto Scroll
    useEffect(() => {
      const handleScroll = () => {
        if (!vasoCafeteroRef.current || !destinoVasoCafeteroRef.current) return;
        // Altura de la pantalla (centro)
        const halfScreen = window.innerHeight / 2;
        const cafeStartOffset = halfScreen;
        const vasoCafe = vasoCafeteroRef.current;

        const contenedor = vasoCafeteroRef.current; // contenedor del vaso y background
        const vasoCafeInd = contenedor.querySelector(".vaso-scroll"); // solo el vaso
        const background = contenedor.querySelector(".background-vasoscroll"); // solo el background

        const startYCafe = vasoCafe.offsetTop; // posición inicial del vaso
        const startPointCafe = startYCafe + cafeStartOffset;
        const endYCafe = destinoVasoCafeteroRef.current.offsetTop; // posición destino
        const scrollYCafe = window.scrollY + window.innerHeight / 2; // referencia de scroll

        // Normalizamos progreso entre 0 y 1
        let progressCafe = (scrollYCafe - startYCafe) / (endYCafe - startYCafe);
        progressCafe = Math.min(Math.max(progressCafe, 0), 1);

        // Rotación progresiva hasta -5°
        const rotation = progressCafe * -5;

        if (scrollYCafe < startPointCafe) {
          vasoCafe.style.transition = `transform 1.5s`;
          // Antes de llegar al inicio → vuelve a su lugar
          vasoCafeInd.style.transform = `rotate(${rotation}deg)`;
          vasoCafe.style.transform = `translateY(${progressCafe * (endYCafe - startYCafe)}px)`;
        } else if (scrollYCafe >= startPointCafe && scrollYCafe < endYCafe) {
          vasoCafe.style.transition = `transform 0.7s`;
          // En movimiento
          vasoCafeInd.style.transform = `rotate(${rotation}deg)`;
          //vasoCafe.style.transform = `translateY(${progressCafe * (endYCafe - startYCafe)}px)`;
          vasoCafe.style.transform = `translateY(${progressCafe * halfScreen}px)`;
        } else {
          vasoCafe.style.transition = `transform 0.9s`;
          // Cuando ya pasó el destino → fijo en el destino
          vasoCafe.style.transform = `translateY(${endYCafe - startYCafe}px)`;
        }
      };

      window.addEventListener("scroll", handleScroll, { passive: true });
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    
//Vasos IML
// Efecto Scroll
    useEffect(() => {
      const handleScroll = () => {
        if (!vasoIMLRef.current || !destinoVasoIMLRef.current) return;
        // Altura de la pantalla (centro)
        const halfScreen = window.innerHeight / 2;
        const imlStartOffset = halfScreen;
        const vasoIML = vasoIMLRef.current;
        
        const contenedor = vasoIMLRef.current; // contenedor del vaso y background
        const vasoRight = contenedor.querySelector(".vaso-iml2"); // solo el vaso
        const vasoLeft = contenedor.querySelector(".vaso-iml1"); // solo el vaso
        const background = contenedor.querySelector(".background-vasoscroll"); // solo el background

        const startYIML = vasoIML.offsetTop; // posición inicial del vaso
        const startPointIML = startYIML + imlStartOffset;
        const endYIML = destinoVasoIMLRef.current.offsetTop; // posición destino
        const scrollYIML = window.scrollY + window.innerHeight / 2; // referencia de scroll

        // Normalizamos progreso entre 0 y 1
        let progressIML = (scrollYIML - startYIML) / (endYIML - startYIML);
        progressIML = Math.min(Math.max(progressIML, 0), 1);

        // Rotación progresiva hasta -5°
        const rotationLeft = progressIML * -5;
        // Rotación progresiva hasta 5°
        const rotationRight = progressIML * 5;

        if (scrollYIML < startPointIML) {
          vasoIML.style.transition = `transform 1.5s`;
          //Sube
          // Antes de llegar al inicio → vuelve a su lugar
          vasoRight.style.transform = `rotate(${rotationRight}deg)`;
          vasoLeft.style.transform = `rotate(${rotationRight}deg)`;
          //vasoIML.style.transform = `translateY(${progressIML * (endYIML - startYIML)}px)`;
          vasoIML.style.transform = `translateY(${progressIML * (window.innerHeight / 4)}px)`;
        } else if (scrollYIML >= startPointIML && scrollYIML < endYIML) {
          
          // En movimiento
          //Baja
          vasoRight.style.transform = `rotate(${rotationLeft}deg)`;
          vasoLeft.style.transform = `rotate(${rotationRight}deg)`;
          vasoIML.style.transition = `transform 0.2s`;
          vasoIML.style.transform = `translateY(${progressIML * halfScreen}px)`;
          //vasoIML.style.transform = `translateY(${progressIML * (endYIML - startYIML)}px)`;
        } else {
          vasoIML.style.transition = `transform 0.9s`;
          // Cuando ya pasó el destino → fijo en el destino
          vasoIML.style.transform = `translateY(${endYIML - startYIML}px)`;
          //vasoIML.style.transform = `translateY(${endYIML - startYIML}px)`;
        }
      };

      window.addEventListener("scroll", handleScroll, { passive: true });
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

  //Slider Botones
  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = 3; // 👈 cámbialo por el número total de slides que tengas

  useEffect(() => {
    const carousel = document.getElementById("carouselVasos");

    const handleSlide = (e) => {
      setActiveIndex(e.to); // índice de la diapositiva activa
    };

    carousel.addEventListener("slid.bs.carousel", handleSlide);

    return () => {
      carousel.removeEventListener("slid.bs.carousel", handleSlide);
    };
  }, []);
  /*const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const carousel = document.getElementById("carouselVasos");

    const handleSlide = (e) => {
      setActiveIndex(e.to); // índice de la diapositiva activa
    };

    carousel.addEventListener("slid.bs.carousel", handleSlide);

    return () => {
      carousel.removeEventListener("slid.bs.carousel", handleSlide);
    };
  }, []);*/

  //Carousel de Vasos
  const [visibleIndex, setVisibleIndex] = useState(0);

  useEffect(() => {
    const items = document.querySelectorAll(".parallax-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.dataset.index);
            setVisibleIndex(index);
          }
        });
      },
      {
        threshold: 0.5, 
      }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);
  //Scroll menu
  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };



  //Efecto de los elementos al entrar
    useEffect(() => {
      const items = document.querySelectorAll(".fade-landing");
  
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
            } else {
              entry.target.classList.remove("animate");
            }
          });
        },
        { threshold: 0.3 }
      );
  
      items.forEach((item) => observer.observe(item));
  
      return () => {
        items.forEach((item) => observer.unobserve(item));
      };
    }, []);



      /*
      useEffect(() => {
        const carouselElement = document.querySelector('#carouselExampleIndicators');
        if (carouselElement && window.bootstrap) {
          const carousel = new window.bootstrap.Carousel(carouselElement, {
            interval: 5000,
            ride: 'carousel',
            pause: false,
            wrap: true
          });
        }
      }, []);

      
      
      */
     useEffect(() => {
      const carouselElement = document.querySelector('#carouselExampleIndicators');

      if (carouselElement) {
        const carousel = new window.bootstrap.Carousel(carouselElement, {
          interval: 7000,
          ride: 'carousel',
          pause: false,
          wrap: true
        });
      }
    }, []);


  return (
    <div id='landing'>
      <div id="carouselExampleIndicators" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000" data-bs-pause="false">
        {/**MObile */}
        <div className='d-block d-md-none mobile'>
          <div className="carousel-indicators w-100 m-0 my-2">
            <div className='d-flex background-indicators'>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
              
            </div>
          </div>
        </div>
        {/**Desktop */}
        <div className='d-none d-md-block'>
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
          </div>
        </div>
        <div className="carousel-inner ">
          {/*Primer Slider data-bs-interval="5000"*/}
          <div className="carousel-item active slider-one" >
            <img src={banner1landing} className="d-block background-slider-landing" alt="background Slider"/>
            <div className="carousel-caption ">
              <div className='container-fluid'>
                <div className='row'>
                  <div className='fade-target texto-left-sliderlanding col-md-7 col-12 d-flex flex-column justify-content-center align-items-start ps-md-5'>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      Esto no es un vaso.
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'white' }}> Es una etiqueta</span>
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'white' }}>hecha vaso</span>
                    </h1>
                    <p className=" lightblack mb-0  mt-3 text-start" style={{ color: 'white', fontWeight: 'bolder', fontSize:'2rem'  }}>
                      (Que no es lo mismo)
                    </p>
                    <div className="d-flex gap-1 justify-content-center">
                      <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom my-5 p-3 gap-2" style={{background:'white', color:'var(--color-text-negro-light)'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                        </svg>
                          Etiqueta tu marca con nosotros
                      </a>
                    </div>
                  </div>
                  <div className='fade-target col-md-5 col-12'>
                    <div className=' cont-vaso-landing-slider'>
                    <div className='tag-vaso-landing-slider fade-target' style={{left: '-29%'}}>
                        <p style={{color:'white'}}>Ideal para</p>
                        <p style={{}}><span style={{color:'white', background: 'rgba(255, 255, 255, 0.2)', padding:'5% 10%', borderRadius:'20px 20px', fontWeight:'bolder'}}>Conciertos</span></p>
                        
                        <div style={{background:'white'}} className='line-tag-h'></div>
                        <div style={{background:'white'}} className='line-tag-v'></div>
                    </div>
                    <AnimacionVasos className='vaso-landing-slider background-slider' imageSrc={vasoRBDHuge} altText="Vaso RBD" />
                    {/*<AnimacionVasos className="vaso-landing-slider background-slider"/>*/}
                  </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Segundo Slider data-bs-interval="5000"*/}
          <div className="carousel-item  slider-two" >
            <img src={banner2landing} className="d-block background-slider-landing" alt="background Slider"/>
            <div className="carousel-caption">
              <div className='container-fluid'>
                <div className='row'>
                  <div className='fade-target texto-left-sliderlanding col-md-7 col-12 d-flex flex-column justify-content-center align-items-start ps-md-5'>
                      <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                        <span style={{ color: 'var(--color-principal)' }}>Tu marca</span>
                      </h1>
                      <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                        <span style={{ color: 'var(--color-text-negro-light)' }}>en boca de todos.</span>
                      </h1>
                      <p className=" lightblack mb-0 mt-3 text-start"  style={{ color: 'var(--color-texr-gris-dark)', fontWeight: 'bolder', fontSize:'2rem' }}>
                        Nuestros vasos dan de qué hablar.
                      </p>
                      {/*
                        import logoDisney from '../assets/sliders/Disney_Color.png';
                        import logoNBCU from '../assets/sliders/NBCUniversal_Color.png';
                      
                      */}
                      {/*
                        <img src={logoDisney} className="" alt="Logo Disney"/>
                        <img src={logoNBCU} className="" alt="Logo NBC UNIVERSAL"/>
                      */}
                      {/*<div className="d-flex gap-1 justify-content-center">*/}
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-md-4 col-12 text-start ps-md-0 ps-md-auto'>
                            <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom my-5 p-3 gap-2" >
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                              </svg>
                                Diseña el tuyo
                            </a>
                          </div>
                          <div className='col-md-8 col-12 text-start pt-md-3'>
                            <img style={{width: '30%'}} src={logoDisney} className="log-moana" alt="Logo Disney"/>
                            <img style={{width: '30%'}} src={logoNBCU} className="log-moana" alt="Logo NBC UNIVERSAL"/>
                          </div>
                        </div>
                        
                        
                      </div>
                  </div>
                  <div className='fade-target col-md-5 col-12'>
                    <div className='cont-vaso-landing-slider'>
                    <div className='tag-vaso-landing-slider fade-target' style={{left: '-29%'}}>
                        <p style={{color:'black'}}>Ideal para</p>
                        <p style={{}}><span style={{color:'black', background: 'rgba(158, 158, 158, 0.2)', padding:'5% 10%', borderRadius:'20px 20px', fontWeight:'bolder'}}>Películas</span></p>
                        
                        <div style={{background:'black'}} className='line-tag-h'></div>
                        <div style={{background:'black'}} className='line-tag-v'></div>
                    </div>
                    <AnimacionVasos className="vaso-landing-slider background-slider" imageSrc={vasoMoanaHuge} altText="Vaso RBD" />
                    {/*<AnimacionVasos className="vaso-landing-slider background-slider"/>*/}
                  </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/*Tercer Slider data-bs-interval="5000"*/}
          <div className="carousel-item slider-three" >
            <img src={banner3landing} className="d-block background-slider-landing" alt="background Slider"/>
            <div className="carousel-caption ">
              <div className='container-fluid'>
                <div className='row'>
                  <div className='fade-target texto-left-sliderlanding col-md-7 col-12 d-flex flex-column justify-content-center align-items-start ps-md-5'>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start" style={{ color: 'var(--color-principal)' }}>
                      Ser referentes en la
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'var(--color-principal)' }}>industria implica</span>
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'var(--color-secundario-blanco)' }}>ser diferentes.</span>
                    </h1>
                    <p className=" mb-0 mt-3 text-start" style={{ color: 'var(--color-secundario-blanco)' , fontWeight: 'bolder', fontSize:'2rem'}}>
                      ¿Quieres un vaso diferente?
                    </p>
                    <p className=" lightblack mb-0 text-start" style={{ color: 'var(--color-secundario-blanco)' , fontWeight: 'bold', fontSize:'1.5rem' }}>
                      Vasos que cambian de color con la temperatura, 
                    </p>
                    <p className=" lightblack mb-0 text-start" style={{ color: 'var(--color-secundario-blanco)', fontWeight: 'bold', fontSize:'1.5rem' }}>
                      fluorescentes, metálicos o con textura... 
                    </p>
                    <p className=" lightblack mb-0 text-start" style={{ color: 'var(--color-secundario-blanco)', fontWeight: 'bold',  fontSize:'1.5rem'}}>
                      tú decides qué tan único lo quieres.
                    </p>
                    <div className="d-flex gap-1 justify-content-center">
                      <a href="#" className="btn btn-custom my-md-5 my-2 p-3 gap-2" >
                          Ver opciones
                      </a>
                    </div>
                  </div>
                  <div className='fade-target col-md-5 col-12 '>
                    <div className=' cont-vaso-landing-slider'>
                    <div className='tag-vaso-landing-slider fade-target' style={{left: '-29%'}}>
                        <p style={{color:'white'}}>Ideal para</p>
                        <p style={{}}><span style={{color:'white', background: 'rgba(255, 255, 255, 0.2)', padding:'5% 10%', borderRadius:'20px 20px', fontWeight:'bolder'}}>Deportes</span></p>
                        
                        <div style={{background:'white'}} className='line-tag-h'></div>
                        <div style={{background:'white'}} className='line-tag-v'></div>
                    </div>
                    <AnimacionVasos className="vaso-landing-slider baseball background-slider" imageSrc={vasoBaseballHuge} altText="BaseBall" />
                    
                    {/*<AnimacionVasos className="vaso-landing-slider background-slider"/>*/}
                  </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Cuarto Slider data-bs-interval="5000"*/}
          <div className="carousel-item slider-three" >
            <img src={banner2landing} className="d-block background-slider-landing" alt="background Slider"/>
            <div className="carousel-caption ">
              <div className='container-fluid'>
                <div className='row'>
                  {/** */}
                  <div className='fade-target texto-left-sliderlanding col-md-7 col-12 d-flex flex-column justify-content-center align-items-start ps-md-5'>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start" style={{ color: 'var(--color-principal)' }}>
                      Si los vasos hablaran,
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'var(--color-text-negro-light)' }}>contarían tu historia</span>
                    </h1>
                    <h1 className="display-4 lightblack mb-0 tit-principal tit-slider text-start">
                      <span style={{ color: 'var(--color-text-negro-light)' }}>una y otra vez</span>
                    </h1>
                    <p className=" lightblack mb-0 mt-3 text-start" style={{  fontWeight: 'bold', fontSize:'1.5rem', color: 'var(--colors-landing-gray)' , fontWeight:'bold' }}>
                      Acompaña en el día a día a tus clientes
                    </p>
                    <p className=" lightblack mb-0 " style={{ color: 'var(--colors-landing-gray)',  fontWeight: 'bold', fontSize:'1.5rem' }}>
                      con nuestros vasos
                    </p>
                    
                  <div className="d-flex gap-1 justify-content-center">
                    <a href="#" className="btn btn-custom my-5 p-3 gap-2" >
                        Ver tipo de vasos
                    </a>
                  </div>
                </div>
                <div className='col-md-5 col-12'>
                  <div className=' cont-vaso-landing-slider fade-target'>
                    <div className='tag-vaso-landing-slider '>
                        <p style={{color:'black'}}>Ideal para</p>
                        <p style={{}}><span style={{color:'black', background: 'rgba(0,0,0,0.2)', padding:'5% 10%', borderRadius:'20px 20px', fontWeight:'bolder'}}>Cafeterías</span></p>
                        
                        <div className='line-tag-h'></div>
                        <div className='line-tag-v'></div>
                    </div>
                    <img src={vasobanner04} className="vaso-landing-slider" alt="background Slider"/>
                  </div>
                </div>

                </div>
              </div>
            </div>
          </div>
          {/** carousel-control-prev carousel-control-next*/}
          {/*<a className="left carousel-control" href="#carouselExampleIndicators" data-slide="prev">
            <span className="glyphicon glyphicon-chevron-left"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="right carousel-control" href="#carouselExampleIndicators" data-slide="next">
            <span className="glyphicon glyphicon-chevron-right"></span>
            <span className="sr-only">Next</span>
          </a>*/}



          {/*<button onClick={prevSlide} className="btn btn-slider carousel-control" aria-label="Anterior slide" stype="button" data-bs-target="#carouselExampleIndicators">
              <span data-bs-slide="prev" className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button data-bs-slide="next" onClick={nextSlide} className="btn btn-slider carousel-control" aria-label="Siguiente slide"  type="button" data-bs-target="#carouselExampleIndicators">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>*/}
        </div>
      </div>



      {/* Vaso cervecero */}
      <section id='vasos-cerveceros'>
        <div className='container-fluid'>
          <div className='row text-center padding-vasoscroll start-vasoscroll fade-up fade-landing'>
            <h1 style={{color:'var(--color-principal)'}}>{vasosLanding[0].nombre}</h1>
            <h1 className='down' style={{color:'var(--color-text-negro-light)'}}>{vasosLanding[0].sub}</h1>
            <p className='subdescrip'>{vasosLanding[0].subdescrip}</p>
          </div>
          <div className='row pt-md-5 pb-md-5 padding-vasoscroll'>
            <div className='col-md-4 col-12 order-md-0 order-1 d-flex align-items-center fade-up fade-landing'>
              {/*43px */}
              <p className='description' style={{width: '90%',color:'var(--color-text-negro-light)'}}>
                <strong>{vasosLanding[0].descripcion}</strong>
              </p>
              
            </div>
            {/*Contenedor de vaso Movible*/}
            <div className='col-md-4 col-12 order-md-1 order-0 '>
              {/*Vaso Desktop*/}
              <div className='d-none d-md-block contenedor-vasosscroll h-screen relative'>
                <div ref={vasoCerveceroRef}  className="absolute" >
                  <div className="fade-landing zoom-in">
                    <img src={vasosLanding[0].imgbackgroundvaso} className=" background-vasoscroll" alt="Background Vaso Cervercero"/>
                    <img 
                      src={vasosLanding[0].imgvaso} 
                      className="vaso-scroll fade-landing zoom-in" 
                      alt="Vaso Cervecero"
                    />
                  </div>
                </div>
              </div>
              {/*Vaso Mobile*/}
              <div className='d-block d-md-none pt-3 pb-5'>
                <div className="contenedor-vasosscroll" >
                  <img src={vasosLanding[0].imgbackgroundvaso} className="background-vasoscroll" alt="Background Vaso Cervercero"/>
                  <img 
                    src={vasosLanding[0].imgvaso} 
                    className="vaso-scroll" 
                    alt="Vaso Cervecero"
                  />
                </div>
              </div>
            </div>
            <div className='fade-up fade-landing col-md-4 col-12 order-md-2 order-2 d-flex justify-content-center align-items-center'>
              <p className=' description2'>
                {vasosLanding[0].descripcion2}
              </p>
            </div>
          </div>
          <div className='row padding-vasoscroll'>
            <div style={{display:'block', height: '10px' }} ref={destinoVasoCerveceroRef}></div>
            <div className='col-12 caracteristica1 fade-up fade-landing'>
              {/*transform: translateY(550px); */}
              
              <p className='text-caract'>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[0].caracteristicas[0]}
              </p>
            </div>
            <div className='col-12 caracteristica2 fade-up fade-landing'>
              <p className='text-caract'>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[0].caracteristicas[1]}
              </p>
            </div>
            
            <div className='col-12 caracteristica3 fade-up fade-landing'>
              
              <p className='text-caract'>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[0].caracteristicas[2]}
              </p>
            </div>
            <div className='col-12 caracteristica4 fade-up fade-landing'>
              <p className='text-caract'>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[0].caracteristicas[3]}
              </p>
            </div>
            
            <div className='col-12'>
              
            </div>
          </div>
          {/* Frase */}
          <div className='row frase-vasoscroll fade-up fade-landing'>
            {/*63px*/}
            <p className='big'>
              Si lo piensas bien,<br/>
              <span className='frase-style'>impactas más y de cerca</span> <br/>
              que con un espectacular.
            </p>
            <div className="d-flex gap-3 justify-content-center">
              <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-2 p-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                </svg>
                Cotiza tu proyecto
              </a>
            </div>
          </div>
        </div>
      </section>



      {/* Vaso cafetero */}
      <section id='vasos-cafeteros' style={{background:'var(--color-text-gris-light)'}}>
        <div className='container-fluid'>
          <div className='row start-vasoscroll text-center padding-vasoscroll fade-up fade-landing'>
            <h1 style={{color:'var(--color-principal)'}}>{vasosLanding[1].nombre}</h1>
            <h1 className='description' style={{color:'var(--color-secundario-blanco)'}}>{vasosLanding[1].sub}</h1>
            <p className='subdescrip'>{vasosLanding[1].subdescrip}</p>
          </div>
          <div className='row pt-md-5 pb-md-5 padding-vasoscroll'>
            <div className='fade-up fade-landing col-md-4 col-12 order-md-0 order-1 d-flex flex-column justify-content-center align-items-center'>
              {vasosLanding[1].descripcion2.map((texto, i) => (
                <p 
                  key={i} 
                  className="description2" 
                  style={{ color: 'var(--color-secundario-blanco)', textAlign: 'start' }}
                >
                  {texto}
                </p>
              ))}
              {/*<p className='description2' style={{color:'var(--color-secundario-blanco)', textAlign:'start'}}>
                {vasosLanding[1].descripcion2}
              </p>*/}
            </div>
            {/*Contenedor del vaso que sube y baja*/}
            <div className=' col-md-4 col-12 order-md-1 order-0'>
              {/*Versión Desktop*/}
              <div className='d-none d-md-block contenedor-vasosscroll h-screen relative'>
                <div ref={vasoCafeteroRef} className="absolute">
                  <img src={vasosLanding[1].imgbackgroundvaso} className="background-vasoscroll" alt="Background Vaso Cafetero"/>
                  <img 
                    src={vasosLanding[1].imgvaso}
                    className="vaso-scroll" 
                    alt="Vaso Cafetero"
                  />
                </div>
              </div>
              {/*Versión Mobile*/}
              <div className='d-block d-md-none py-5'>
                <div className="contenedor-vasosscroll">
                  <img src={vasosLanding[1].imgbackgroundvaso}  className="background-vasoscroll" alt="Background Vaso Cafetero"/>
                  <img 
                    src={vasosLanding[1].imgvaso}
                    className="vaso-scroll" 
                    alt="Vaso Cafetero"
                  />
                </div>
              </div>
            </div>
            <div className='fade-up fade-landing col-md-4 col-12 order-md-2 order-2 d-flex flex-column justify-content-center align-items-center'>
              <p className='description' style={{color:'var(--color-secundario-blanco)'}}>
                {vasosLanding[1].descripcion}
              </p>
            </div>
          </div>
          <div className='row padding-vasoscroll'>
            <div style={{display:'block', height: '10px' }} ref={destinoVasoCafeteroRef}></div>
            <div className='col-12 caracteristica1 fade-up fade-landing'>
              
              <p className='text-caract' style={{color:'var(--color-secundario-blanco)'}}>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[1].caracteristicas[0]}
              </p>
            </div>
            <div className='col-12 caracteristica2 fade-up fade-landing'>
              <p className='text-caract' style={{color:'var(--color-secundario-blanco)'}}>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[1].caracteristicas[1]}
              </p>
            </div>
            <div className='col-12 caracteristica3 fade-up fade-landing'>
              <p className='text-caract' style={{color:'var(--color-secundario-blanco)'}}>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[1].caracteristicas[2]}
              </p>
            </div>
            <div className='col-12 caracteristica4 fade-up fade-landing'>
              <p className='text-caract' style={{color:'var(--color-secundario-blanco)'}}>
                <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                {vasosLanding[1].caracteristicas[3]}
              </p>
            </div>
          </div>
          {/* Frase */}
          <div className='row frase-vasoscroll fade-up fade-landing'>
            {/*63px*/}
            <p className='big' style={{color:'var(--color-secundario-blanco)'}}>
              Vuélvete el vaso favorito de tus clientes.<br/>
              <span className='frase-style'>Nunca lo querrán soltar.</span>
            </p>
            <div className="d-flex gap-3 justify-content-center">
              <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-2 p-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                </svg>
                Cotiza con nosotros
              </a>
            </div>
          </div>
        </div>
      </section>



      <section className='iml' style={{background:'var(--color-text-negro-light)'}}>
        <div className='container-fluid'>
          {/**Titulo */}
          <div className='row start-vasoscroll text-center padding-vasoscroll fade-up fade-landing pb-md-0'>
            <h1 style={{color:'var(--color-principal)'}}>Más que vasos,</h1>
            <h1 className='down' style={{color:'var(--color-secundario-blanco)'}}>estrategias que duran.</h1>
            <p className='big' style={{color:'var(--color-secundario-blanco)'}} >Colores que hablan. Texturas que sorprenden. Acabados que impactan.</p>
          </div>
          {/**Contenido */}
          <div className='row text-start padding-vasoscroll order-md-1 pb-md-0'>
            <div className='fade-up fade-landing col-lg-7 col-md-6 col-12 order-md-0 order-1 pe-md-5 d-flex flex-column align-items-start justify-content-center'>
              <p className='m-0' style={{color:'var(--color-secundario-blanco)'}}>
                Con etiquetas en molde (IML), múltiples colores de plástico y acabados como piel de naranja, metálico, brillante, fluorescente o que cambian con la temperatura, puedes personalizar cualquier diseño.
              </p>
              <p className='pt-3 m-0' style={{color:'var(--color-secundario-blanco)'}}>
                Con nuestra <strong>Impresión Digital Híbrida</strong> adapta múltiples diseños en una sola producción a cualquier estrategia, temporalidad o promoción.
              </p>
              <p className='pt-md-3 pt-5 m-0' style={{color:'var(--color-secundario-blanco)'}}>
                <strong>Haz que tus vasos duren todo el año.</strong>
              </p>
              
              {/*<div className='col-12 mb-3'>
                <p className='m-0 d-flex flex-row align-items-center w-100' style={{color:'var(--color-secundario-blanco)', width:'100%'}}>
                  <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                  Hasta más de 15 usos por vaso.
                </p>
              </div>*/}
              <div className='col-12 mb-3'>
                <p className='m-0 w-100 d-flex flex-row align-items-center' style={{color:'var(--color-secundario-blanco)'}}>
                  <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                  Más de 15 impactos de marca garantizados en manos de tus clientes.
                </p>
              </div>
              
            </div>
            <div className='col-lg-5 col-md-6 col-12 order-md-1 order-0 pb-md-auto pb-5 d-flex flex-column align-items-center justify-content-center'>
              <div className='d-none d-md-block contenedor-iml h-screen relative'>
                <div ref={vasoIMLRef}  className="absolute" >
                  <img src={backgroundVasosIML} className="background-iml" alt="Background Vaso IML"/>
                  <img src={vasoIML2} className="vaso-iml2" alt="Vaso MegaLabel"/>
                  <img src={vasoIML1} className="vaso-iml1" alt="Vaso Promoción"/>
                  <img src={vasoIML3} className="vaso-iml3" alt="Vaso MegaLabel"/>
                </div>
              </div>
              <div className='d-block d-md-none'>
                <div className="contenedor-iml" >
                  <img src={backgroundVasosIML} className="background-iml" alt="Background Vaso Cervercero"/>
                  <img src={vasoIML1 } className="vaso-iml1" alt="Vaso Promoción"/>
                  <img src={vasoIML2 } className="vaso-iml2" alt="Vaso MegaLabel"/>
                  <img src={vasoIML3} className="vaso-iml3" alt="Vaso MegaLabel"/>
                </div>
              </div>
            </div>
          </div>
          {/* Frase */}
          <div className='row frase-vasoscroll'>
            <div className='contvasosiml' style={{display:'block', height: '10px', marginTop:'-5%'}} ref={destinoVasoIMLRef}></div>
            <div className='col-md-7 col-12 fade-up fade-landing'>
                {/*63px*/}
              <p className='big' style={{color:'var(--color-secundario-blanco)', textAlign:'start'}}>
                Bajo costo.<br/>
                <span className='frase-style'>Gran impacto.</span><br></br>
                Larga vigencia.
              </p>
              <div className="d-flex gap-3 justify-content-start">
                <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-2 p-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                  </svg>
                  Hablemos de tu proyecto
                </a>
              </div>
            </div>
            <div className='col-md-5 col-12'>
              
            </div>
          </div>
        </div>
      </section>



      <section id='impresion-hibrida' style={{transition: "all 0.8s ease-out",}}>
        <div className='container-fluid'>
          <div className='row start-vasoscroll text-center padding-vasoscroll fade-up fade-landing'>
            <h1 style={{color:'var(--color-principal)'}}>Impresión Digital Híbrida:</h1>
            <h1 className='down' style={{color:'var(--color-text-negro-light)'}}>personalización a escala</h1>
            <p style={{color:'var(--color-text-negro-light)'}} >Imagina la flexibilidad de una impresión digital… pero en línea de producción. Con nuestra tecnología híbrida, puedes producir grandes cantidades de vasos sin perder detalle ni creatividad, y mantener tus costos bajo control.</p>
          </div>
          <div className='row padding-vasoscroll align-items-center'> 
            <div className='col-md-3 col-12 order-md-0 order-1 fade-up fade-landing'>
              <div className='col-12 caracteristica2'>
                    <p className='text-caract w-100'>
                      <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                      Acabados premium al instante: barnices, colores especiales, efectos que destacan.
                    </p>
              </div>
              <div className='col-12 caracteristica2 mt-md-5 fade-up fade-landing'>
                    <p className='text-caract w-100'>
                      <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                      Genera varias temporalidades o campañas en una sola producción.
                    </p>
                  </div>
              </div>
              <div className=' col-md-6 col-12 order-md-1 order-0 py-5 d-flex flex-column align-items-center justify-content-center'>
                  <img src={impresionDigitalHibrida} className="mb-md-5 fade-landing zoom-in background-iml" alt="Maquinaria de Impresión"/>
                  {/**Botón versión Desktop */}
                  <div className='d-none d-md-block'>
                    <div className='fade-landing fade-up col-md-12 col-12 order-md-1 order-0 d-flex flex-column align-items-center justify-content-center'>
                      <div className="d-flex gap-3 justify-content-center">
                        <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-2 p-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                          </svg>
                          Hagamos realidad tu sueño
                        </a>
                      </div>
                    </div>
                  </div>
              </div>
              <div className='col-md-3 col-12 order-md-2 order-2 fade-up fade-landing'>
                  <div className='col-12 caracteristica1 mt-md-5'>
                    <p className='text-caract w-100'>
                      <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                      Personalización total, incluso en lotes pequeños.
                    </p>
                  </div>
                  <div className='col-12 caracteristica1 mt-md-5 fade-up fade-landing'>
                    <p className='text-caract w-100'>
                      <img src={imgCheck} className="icon-check" alt="Check Caracteristicas"/> 
                      Producción rápida y eficiente, ideal para campañas masivas o temporales.
                    </p>
                  </div>
                  {/**Botóm versión Mobile*/}
                  <div className='d-block d-md-none'>
                    <div className='fade-landing fade-up col-md-12 col-12 order-md-1 order-0 d-flex flex-column align-items-center justify-content-center'>
                      <div className="d-flex gap-3 justify-content-center">
                        <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-3 mb-4 p-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                          </svg>
                          Hagamos realidad tu sueño
                        </a>
                      </div>
                    </div>
                  </div>
              </div>
              
            </div>
            
        </div>
      </section>
      <section id='muestra-de-vaso'>
        <div className="container-fluid start-vasoscroll padding-vasoscroll">
          <div className='row text-center  fade-up fade-landing'>
            <h1 
            className='tit-principal pb-md-5 pb-3'
              style={{
                color: "var(--color-principal)",
                //position: "sticky",
                //top: 0,
                //background: "white",
                //zIndex: 10,
                //padding: "1rem 0",
              }}
            >
              Para muestra, <span style={{color:'var(--color-text-negro-light)'}}>un </span><span style={{color:'var(--color-gray)', textDecoration: 'line-through'}}>botón</span> <span style={{color:'var(--color-text-negro-light)'}}>vaso</span></h1>
          </div>
          <div className="row">
            <div id="carouselVasos" className="carousel slide" >
            {/*
              data-bs-ride="carousel"
              slide
             */}
            {/**transition: "all 0.8s ease-out", */}
            {/**Carousel de Vasos para Mobile */}
            <div className="d-block d-sm-none">
              <div className="parallax-container">
                {vasos.map((vaso, index) => (
                  <div
                    className="parallax-item"
                    key={index}
                    data-index={index}
                    style={{
                      position: "sticky",
                      //top: "100px", // Punto fijo donde queda visible
                      opacity: visibleIndex === index ? 1 : 0,
                      transform:
                        visibleIndex === index
                          ? "translateY(0px)"
                          : "translateY(50px)",
                      transition: "all 0.8s ease-out",
                    }}
                  >
                    <img
                      src={vaso.src}
                      alt={vaso.nombre}
                      style={{ width: "100%", height: "auto" }}
                    />
                    <p className="nameglass">{vaso.nombre}</p>
                  </div>
                ))}
              </div>
            </div>
            
             {/**Carousel de Vasos para Desktop */}
             {/*<div className='d-none d-sm-block px-md-5'> */}
                {/*<div className="carousel-inner">
                  {slides.map((group, idx) => (
                    <div
                      className={"carousel-item" + (idx === 0 ? " active" : "")}
                      key={idx}
                    >
                      
                      <div className="d-flex">
                        {group.map((src, j) => (
                          <div
                            key={j}
                            style={{
                              flex: "0 0 33.3333%",
                              padding: "0 6px",
                              boxSizing: "border-box",
                            }}
                          >
                            <img
                              src={src.src}
                              alt={src.alt}
                              className="img-fluid"
                              style={{
                                width: "100%",
                                height: "auto",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                            <p className="nameglass">{src.alt}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>*/}
                
                {/*<div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src={vasoColoreable} alt="Vaso Coloreable"/>
                    <p className="nameglass">Coloreable</p>
                  </div>
                  <div className="carousel-item">
                    <img src={vasoHighGloss} alt="Vaso HighGloss"/>
                    <p className="nameglass">High Gloss</p>
                  </div>
                  <div className="carousel-item ">
                    <img src={vasoLisoBrillante} alt="Vaso Liso Brillante"/>
                    <p className="nameglass">Liso Brillante</p>
                  </div>
                  <div className="carousel-item">
                    <img src={vasoMetalizado} alt="Vaso Metalizado"/>
                    <p className="nameglass">Metalizado</p>
                  </div>
                  <div className="carousel-item">
                    <img src={vasoOrangePeel} alt="Vaso OrangePeel"/>
                    <p className="nameglass">Orange Peel</p>
                  </div>
                  <div className="carousel-item">
                    <img src={vasoTransparente} alt="Vaso Transparente"/>
                    <p className="nameglass">Transparente</p>
                  </div>
                  <div className="carousel-item">
                    <img src={vasoTermocromatico} alt="Vaso Termocromático"/>
                    <p className="nameglass">Termocromático</p>
                  </div>*/}
             <div className='d-none d-sm-block px-md-5'>
                  <div className="carousel-inner">
                    <div className="carousel-item active" style={{transition: 'transform 2s ease, opacity .5s ease-out'}}>
                      <div className='container-fluid'>
                        <div className='row align-items-end row-vasos rvasos1'>
                          <div className='col-4'>
                            <img src={vasoColoreable} className="" alt="Vaso Coloreable" />
                            <p className='nameglass'>Coloreable</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoHighGloss} className="" alt="Vaso HighGloss"/>
                            <p className='nameglass'>High Gloss</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoLisoBrillante} className="" alt="Vaso Liso Brillante"/>
                            <p className='nameglass'>Liso Brillante</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item" style={{transition: 'transform 2s ease, opacity .5s ease-out'}}>
                      <div className='container-fluid'>
                        <div className='row align-items-end row-vasos'>
                          {/*<div className='col-4'>
                            <img src={vasoLisoBrillante} className="" alt="Vaso Liso Brillante"/>
                            <p className='nameglass'>Liso Brillante</p>
                          </div>*/}
                          <div className='col-4'>
                            <img src={vasoMetalizado} className="" alt="Vaso Metalizado"/>
                            <p className='nameglass'>Metalizado</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoOrangePeel} className="" alt="Vaso OrangePeel" />
                            <p className='nameglass'>Orange Peel</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoTransparente} className="" alt="Vaso Transparente" />
                            <p className='nameglass'>Transparente</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="carousel-item" style={{transition: 'transform 2s ease, opacity .5s ease-out'}}>
                      <div className='container-fluid'>
                        <div className='row align-items-end row-vasos'>
                          {/*<div className='col-4'>
                            <img src={vasoOrangePeel} className="" alt="Vaso OrangePeel" />
                            <p className='nameglass'>Orange Peel</p>
                          </div>*/}
                          
                          <div className='col-4'>
                            <img src={vasoTermocromatico} className="" alt="Vaso Metalizado"/>
                            <p className='nameglass'>Termocromático</p>
                          </div>
                          <div className='col-4'>
                           {/*</div> <img src={vasoOrangePeel} className="" alt="Vaso OrangePeel" />
                            <p className='nameglass'>Orange Peel</p>*/}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*<div className="carousel-item">
                      <div className='container-fluid'>
                        <div className='row align-items-end'>
                          <div className='col-4'>
                            <img src={vasoTermocromatico} className="d-block w-100" alt="Vaso Metalizado"/>
                            <p className='nameglass'>Termocromático</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoOrangePeel} className="d-block w-100" alt="Vaso OrangePeel" />
                            <p className='nameglass'>Orange Peel</p>
                          </div>
                          <div className='col-4'>
                            <img src={vasoTransparente} className="d-block w-100" alt="Vaso Transparente" />
                            <p className='nameglass'>Transparente</p>
                          </div>
                        </div>
                      </div>
                    </div>*/}
                  
                  {/*
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselVasos" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselVasos" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true"></span>
                      <span className="visually-hidden">Next</span>
                    </button>
                  */}
                  {/*
                  <button 
                    className="carousel-control-prev " 
                    style={{
                      opacity: '1'
                    }}
                    type="button" 
                    data-bs-target="#carouselVasos" 
                    data-bs-slide="prev">
                    <i className="fas fa-arrow-left btn-custom"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--color-principal)',
                        border: 'none',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px'
                      }}
                    ></i>
                  </button>
                  <button className="carousel-control-next" 
                    style={{
                      opacity: '1'
                    }}
                    type="button" 
                    data-bs-target="#carouselVasos" 
                    data-bs-slide="next">
                    <i className="fas fa-arrow-right btn-custom"
                      style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--color-principal)',
                        border: 'none',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px'
                      }}
                    
                    ></i>
                  </button>*/}
                  
            {/* Botón izquierda: solo visible en el segundo slide */}
            {activeIndex > 0 && (
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselVasos"
                data-bs-slide="prev"
                style={{ opacity: 1 }}
              >

                <div
                  className="bi bi-arrow-left btn-custom"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "var(--color-principal)",
                    border: "none",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                  </svg>
                </div>
              </button>
            )}

            {/* Botón derecha: solo visible en el primer slide */}
            {activeIndex < totalSlides - 1 && (
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselVasos"
                data-bs-slide="next"
                style={{ opacity: 1 }}
              >
                {/*<i
                  className="bi bi-arrow-left btn-custom"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "var(--color-principal)",
                    border: "none",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                  }}
                ></i>*/}
                <div
                  className="bi bi-arrow-right btn-custom"
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "var(--color-principal)",
                    border: "none",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                  </svg>
                </div>
                
              </button>
            )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Landing